import IndicationSelectionErrorHtml from './rfct/html/indication-selection-error-html';
import IndicationSelectionHtml from './rfct/html/indication-selection-html';
import IndicationSelectionSkeletonHtml from './rfct/html/indication-selection-skeleton-html';
import ToggleBannerHtml from './rfct/html/toggle-banner-html';
import $ from './rfct/jQuery/jQuery';
import Modal from './rfct/modal/modal';
import moduleRegistry from './rfct/module-registry/module-registry';
import { decodeHtml } from './rfct/utils/utils';
import { Navigation } from '../../../scripts/modules/navigation/navigation';

// eslint-disable-next-line no-undef
let $globalConfig;
if (document.querySelectorAll('.catalog').length > 0 || document.querySelectorAll('.eifu').length > 0) {
    $globalConfig = config;
}

const indicationConfig = {
    selectors: {
        catalog: '.catalog',
        rfctBackButton: '.rfct-search-results__back-link',
        catalogBreadcrumb: '#dinamic-category-breadcrumb-content',
    },
    indicationBannerStorageKey: 'ks-indication-banner',
};

const $document = $(document);
let $breadcrumb;
let taxonomyType;
let catUrlParam;
let helpModal = null;
let indicationModal = null;

function init() {
    const params = new URLSearchParams(window.location.search);
    catUrlParam = !isNaN(params.get('cat')) ? params.get('cat') : '';

    $breadcrumb = $(indicationConfig.selectors.catalogBreadcrumb);
    taxonomyType = $breadcrumb.attr('data-taxonomy-type') || '';

    const categoryType = $breadcrumb.attr('data-category-type');
    const hasChildren = $breadcrumb.attr('data-has-children') === 'true';

    if (categoryType === 'p' && !hasChildren) {
        if($('.rfct-product-detail').length === 0) initIndicationBanner();
    }

    initBackLink();
}

function initIndicationBanner() {
    const indicationBannerHtml = createIndicationBannerHtml();

    if (!indicationBannerHtml) {
        return;
    }

    const $catalog = $(indicationConfig.selectors.catalog);

    moduleRegistry.insertHTML($catalog, indicationBannerHtml, {
        append: true,
        selectorCallbacks: {
            '.rfct-toggle-banner__action-button-container .rfct-button': (actionButton) => {
                $(actionButton).on('click', () => {
                    handleActionButtonClick();
                });
            },
            '.rfct-toggle-banner__help-button-container .rfct-button': (helpButton) => {
                $(helpButton).on('click', () => {
                    handleHelpButtonClick();
                });
            },
        },
    });

    initOpenCloseIndicationBannerListeners();
    initSubmitIndicationSelectionListener();
}

function createIndicationBannerHtml() {
    // eslint-disable-next-line no-undef
    const textResources = $globalConfig.textResources.productCatalogConnectorConfig;
    const text = textResources.indicationBannerText || '';

    if (!text) {
        return null;
    }

    return new ToggleBannerHtml({
        open: getIndicationBannerState(true),
        openText: textResources.indicationBannerOpen,
        closeText: textResources.indicationBannerClose,
        text: textResources.indicationBannerText || '',
        actionButton: {
            text: textResources.indicationBannerActionButtonText || '',
        },
        helpButton: {
            text: textResources.indicationBannerHelpButtonText || '',
        },
    });
}

function handleActionButtonClick() {
    if (!indicationModal) {
        indicationModal = createIndicationModal();
    } else {
        window.dispatchEvent(
            new CustomEvent('open-checkout-dialog', { detail: {} })
        );
    }
    
    // eslint-disable-next-line camelcase
    if (typeof _etracker !== 'undefined' && typeof et_pagename !== 'undefined') {
        // eslint-disable-next-line no-undef, new-cap
        _etracker.sendEvent(new et_UserDefinedEvent(et_pagename, 'ADDALLPRODUCTS|CATALOG', 'StartFunction', taxonomyType));
    }
}

function createIndicationModal(bool = false) {
    const textResources = $globalConfig.textResources.productCatalogConnectorConfig;

    const modal = new Modal(
        new IndicationSelectionSkeletonHtml(5).toString(),
        'indication-modal', {
            large: true,
            cssClass: 'rfct-modal--indication',
        },
    );

    const handleLoadIndicationsSuccess = (indicationData) => {
        console.log('indicationData', indicationData);
        const eventPayload = {
            indicationName: indicationData.indication?.name,
            indicationId: indicationData.indication?.identifier,
            indicationPosition: indicationData.indication?.position,
            products: indicationData.products
        };

        window.dispatchEvent(
            new CustomEvent('indicationProductsFetched', { detail: eventPayload })
        );
    };

    const handleLoadIndicationsError = () => {
        modal.setContent(
            new IndicationSelectionErrorHtml(
                textResources.indicationSelectionNoProductsError,
            ).toString(),
        );
    };

    loadIndications().done((indicationData) => {
        if (
            !indicationData
            || !indicationData.indication
            || !indicationData.products
            || !indicationData.products.length
        ) {
            handleLoadIndicationsError();
            return;
        }

        handleLoadIndicationsSuccess(indicationData);
    }).fail(() => {
        handleLoadIndicationsError();
    });

    return modal;
}

function loadIndications() {
    return $.get(`${$globalConfig.urls.getIndications}/${catUrlParam}`);
}

function createProductDetailLink(product) {
    return `${$globalConfig.urls.productDetailPageHtml}?productID=${product.identifier}&cat=${catUrlParam}`;
}

function handleSubmitButtonClick() {
    // eslint-disable-next-line camelcase
    if (typeof _etracker !== 'undefined' && typeof et_pagename !== 'undefined') {
        // eslint-disable-next-line no-undef, new-cap
        _etracker.sendEvent(new et_UserDefinedEvent(et_pagename, 'ADDALLPRODUCTS|CATALOG', 'AddToBasket', taxonomyType));
    }
}

function handleHelpButtonClick() {
    if (!helpModal) {
        helpModal = createHelpModal();
    }

    helpModal.show();

    // eslint-disable-next-line camelcase
    if (typeof _etracker !== 'undefined' && typeof et_pagename !== 'undefined') {
        // eslint-disable-next-line no-undef, new-cap
        _etracker.sendEvent(new et_UserDefinedEvent(et_pagename, 'ADDALLPRODUCTS|CATALOG', 'Help', taxonomyType));
    }
}

function createHelpModal() {
    const textResources = $globalConfig.textResources.productCatalogConnectorConfig;
    const modalContent = decodeHtml(textResources.indicationHelpModalContent);
    const buttonText = textResources.indicationHelpModalConfirmButtonText;
    const buttons = [];

    if (buttonText) {
        buttons.push({
            type: 'primary',
            text: buttonText,
            onClick: () => {
                helpModal.hide();
            },
        });
    }

    return new Modal(
        modalContent,
        'indication-help-modal',
        {
            buttons,
        },
    );
}

function initOpenCloseIndicationBannerListeners() {
    $document.on('rfct:togglebanneropen', () => {
        saveIndicationBannerState(true);
    });

    $document.on('rfct:togglebannerclose', () => {
        saveIndicationBannerState(false);
    });
}

function saveIndicationBannerState(state) {
    const storageValue = {
        state: state ? 1 : 0,
        timestamp: Date.now(),
    };

    localStorage.setItem(
        indicationConfig.indicationBannerStorageKey,
        JSON.stringify(storageValue),
    );
}


function getIndicationBannerState(defaultValue) {
    let storageValue;

    try {
        storageValue = JSON.parse(
            localStorage.getItem(indicationConfig.indicationBannerStorageKey),
        );
    } catch (error) {
        return defaultValue;
    }

    if (!storageValue) {
        return defaultValue;
    }

    const defaultStoreStateDays = 1;
    let storeStateDays;

    try {
        storeStateDays = parseFloat($globalConfig.indicationBanner.storeStateDays);
    } catch (error) {
        storeStateDays = defaultStoreStateDays;
    }

    if (!storeStateDays) {
        storeStateDays = defaultStoreStateDays;
    }

    const now = Date.now();
    const isExpired = storageValue.timestamp < (
        now - (storeStateDays * 24 * 60 * 60 * 1000)
        // now - (15 * 1000)
    );

    if (isExpired) {
        // storage value expired
        return defaultValue;
    }

    return !!storageValue.state;
}

function initSubmitIndicationSelectionListener() {
    $document.on('rfct:submitindicationselection', (e) => {
        const productSelection = e.detail;

        if (productSelection.totalQuantity <= 0) {
            // no products selected
            return;
        }

        indicationModal.hide();
        addProductsToBasket(productSelection);
    });
}


function addProductsToBasket(productSelection) {
    const productSpecialty = $breadcrumb.attr('data-product-specialty-identifier');
    const productDivision = $breadcrumb.attr('data-product-division-identifier');
    const categoryId = $breadcrumb.attr('data-category-id');
    const formData = new FormData();

    productSelection.products.forEach((product) => {
        const singleProduct = `<root><id>${product.identifier}</id>
            <title>${encodeURIComponent(product.name)}</title>
            <amount>${product.quantity}</amount>
            <link>${encodeURIComponent(createProductDetailLink(product))}</link>
            <category>${categoryId}</category>
            <catalog>${productSpecialty}</catalog>
            <abstract>${product.articleName}</abstract>
            <division>${productDivision}</division>
            <tx>${product.tipForBasket || ''}</tx></root>`;

        formData.append('product', singleProduct);

        // addProduct({
        //     productId: product.identifier,
        //     articleNumber: product.identifier,
        //     productName: product.name,
        //     quantity: product.quantity,
        //     imageSrc: product.imageSrc,
        //     href: createProductDetailLink(product),
        // });
    });

    $.ajax({
        type: 'POST',
        url: `${$globalConfig.urls.addToCart}?action=addmultipleproducts`,
        data: formData,
        processData: false,
        contentType: false,
        success(data) {
            const mediaquery = window.matchMedia('(max-width: 991px)');

            if (mediaquery.matches) {
                $('#ks-cart-count').replaceWith(data);
                $('#ks-mobile-button-cart').animate({ opacity: 0 }, 500);
                $('#ks-mobile-button-cart').addClass('full');
                $('#ks-mobile-button-cart').animate({ opacity: 1 }, 500);
            } else {
                $('#ks-top-cart-dialog').animate({ opacity: 0 }, 500);
                $('#ks-cart-count').replaceWith(data);
                $('#ks-top-cart-dialog').animate({ opacity: 1 }, 500);
                $('#ks-mobile-button-cart').addClass('full');
            }

            showBasketResultToaster(true, productSelection.totalQuantity);
            trackAddProductsToBasket(productSelection);
        },
        error(error) {
            // eslint-disable-next-line no-console
            console.error('Failed to add products to basket', error);
            showBasketResultToaster(false, productSelection.totalQuantity);
        },
    });
}

function addProduct(product) {
    const LOCAL_STORAGE_KEY = 'ks-checkout-products';
    const LOCAL_STORAGE_HREF_KEY = 'ks-checkout-back-href';
    const json = localStorage.getItem(LOCAL_STORAGE_KEY);
    const localStorageProductsMap = json ? JSON.parse(json) : {};

    if(localStorageProductsMap[product.productId]) {
        localStorageProductsMap[product.productId].quantity = localStorageProductsMap[product.productId].quantity + 1;
    } else {
        localStorageProductsMap[product.productId] = product;
    }
    
    localStorage.setItem(LOCAL_STORAGE_HREF_KEY, window.location.pathname + window.location.search); 
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(localStorageProductsMap)); 

    Navigation.updateCartNumber();
}

function showBasketResultToaster(success, productQuantity) {
    const textResources = $globalConfig.textResources.productCatalogConnectorConfig;
    let message = success
        ? textResources.indicationSelectionToasterSuccess
        : textResources.indicationSelectionToasterError;
    message = `<div>${message}</div>`.replace(/{\s?productCount\s?}/g, productQuantity);

    if (success) {
        // eslint-disable-next-line no-undef
        toastr.options.onclick = () => {
            const $basketLink = $('.navigation__action.navigation__action--favorite > a');

            if ($basketLink.length) {
                // click the basket link so that the user
                // navigates to the basket page when he
                // clicked a toastr popup
                $basketLink[0].click();
            }

            // eslint-disable-next-line no-undef
            toastr.options.onclick = null;
        };

        // eslint-disable-next-line no-undef
        toastr.info(message);
    } else {
        // eslint-disable-next-line no-undef
        toastr.error(message);
    }
}

function trackAddProductsToBasket(productSelection) {
    if (typeof etCommerce === 'undefined') {
        return;
    }

    const $body = $(document.body);
    const basketId = $body.attr('data-sid');
    const etrackerCategory = [];

    // eslint-disable-next-line no-undef
    if (typeof etrackerCategoryForOrder !== 'undefined' && etrackerCategoryForOrder.length) {
        // eslint-disable-next-line no-undef
        etrackerCategoryForOrder.forEach((etrackerCategoryItem) => {
            etrackerCategory.push(etrackerCategoryItem);
        });
        etrackerCategory.push('Indications-Overlay');
    } else {
        etrackerCategory.push('Indications-Overlay');
    }

    productSelection.products.forEach((product) => {
        const etCommerceProduct = {
            id: product.identifier,
            name: product.articleName,
            category: etrackerCategory,
            price: '1.00',
            currency: 'EUR',
            variants: {},
        };

        // eslint-disable-next-line no-undef
        etCommerce.sendEvent('viewProduct', etCommerceProduct);
        // eslint-disable-next-line no-undef
        etCommerce.sendEvent('insertToBasket', etCommerceProduct, product.quantity, basketId);
    });
}

function initBackLink() {
    const $rfctBackLink = $(indicationConfig.selectors.rfctBackButton);
    const backLinkHref = $rfctBackLink.attr('href');

    if (!backLinkHref || backLinkHref === '#') {
        $rfctBackLink.on('click', (e) => {
            e.preventDefault();

            if (window.history.length) {
                window.history.back();
            } else {
                window.history.pushState('', '', `${$globalConfig.urls.areaOfExpertiseHtml}?cat=123`);
            }
        });
    }
}

if (document.querySelectorAll('.catalog').length > 0 || document.querySelectorAll('.eifu').length > 0) {
    init();
}
